import { FC, ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Props = {
  title: ReactNode
  subtitle?: string
  children?: ReactNode
  className?: string
}

const SettingsTitle: FC<Props> = ({ title, subtitle, children, className }) => {
  return (
    <div
      className={cn(
        'flex sm:flex-row flex-col mx-auto pb-4 w-full border-b rounded-t-xl items-center justify-center',
        className
      )}
    >
      <div className="flex flex-row items-center justify-between w-full mx-auto max-w-7xl">
        <div className="flex flex-col justify-center gap-2 ">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          <span className="text-base text-muted-foreground">{subtitle}</span>
        </div>
        <div className="flex justify-end ">{children}</div>
      </div>
    </div>
  )
}

export default SettingsTitle
